<template>
    <div class="deliver-wrap">
        <el-button type="success" size="mini" @click="handleAddType('')" style="margin-bottom: 20px">新增</el-button>

        <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="freightCityNames" label="运费城市"></el-table-column>
            <el-table-column prop="deliveryType1" label="冷链" width="100">
                <template slot-scope="scope">
                    {{formatDeliveryType(scope.row.deliveryType1)}}
                </template>
            </el-table-column>
            <el-table-column prop="deliveryType2" label="常温" width="100">
                <template slot-scope="scope">
                    {{formatDeliveryType(scope.row.deliveryType2)}}
                </template>
            </el-table-column>
            <el-table-column prop="deliveryType3" label="急速达" width="100">
                <template slot-scope="scope">
                    {{formatDeliveryType(scope.row.deliveryType3)}}
                </template>
            </el-table-column>
            <el-table-column prop="deliveryType4" label="超级会员冷链" width="100">
                <template slot-scope="scope">
                    {{formatDeliveryType(scope.row.deliveryType4)}}
                </template>
            </el-table-column>
            <el-table-column prop="deliveryType5" label="超级会员常温" width="100">
                <template slot-scope="scope">
                    {{formatDeliveryType(scope.row.deliveryType5)}}
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="180" >
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="primary" size="mini" @click="handleAddType(scope.row.unifyId)">修改</el-button>
                        <el-button type="warning" v-if="scope.row.unifyId != '-1'" size="mini" @click="deleteFreight(scope.row.unifyId)">删除</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>

        <el-dialog title="修改/新增运费城市" :visible.sync="dialogFormVisible" center @close="resetDeliverData">
            <el-form :model="deliverLabel[0].data" label-width="120px">
                <el-form-item label="">
                    <el-popover
                            placement="bottom"
                            width="400"
                            trigger="click"
                            v-if="selectId != '-1'">
                        <el-tree
                                :data="options"
                                :props="props"
                                node-key="id"
                                show-checkbox style="height: 300px;overflow-y: scroll"
                                ref="tree"
                                @check-change="handleCheckChange">
                        </el-tree>
                        <el-button slot="reference" type="primary">请选择城市</el-button>
                    </el-popover>
                    <p style="margin-bottom: 0">已选: {{deliverLabel[0].data.freightCityNames}}</p>
                </el-form-item>
            </el-form>

            <el-tabs tab-position="left" v-model="activeName">
                <template v-for="item in deliverLabel">
                    <el-tab-pane :label="item.name">
                        <el-form :model="item.data" label-width="120px">
                            <el-form-item label="起送金额">
                                <el-input-number v-model="item.data.sendAmount" :precision="0" controls-position="right" :min="0"></el-input-number>
                            </el-form-item>
                            <el-form-item label="免运费金额">
                                <el-input-number v-model="item.data.freightFreeAmount" :precision="0" controls-position="right" :min="0"></el-input-number>
                            </el-form-item>
                            <el-form-item label="运费区间">
                                <el-row v-for="(item1,index1) in item.data.freightRules" :key="index1" style="margin-bottom: 10px">
                                    <el-col :span="4">
                                        <el-input-number v-if="index1==0" v-model="item1.beginAmount" :precision="0" controls-position="right" :min="0"></el-input-number>
                                        <el-input-number v-else disabled v-model="item.data.freightRules[index1-1].endAmount" :data-end="item1.beginAmount = item.data.freightRules[index1-1].endAmount" :precision="0" controls-position="right"></el-input-number>

                                    </el-col>
                                    <el-col :span="1" class="line">—</el-col>
                                    <el-col :span="4">
                                        <el-input-number v-model="item1.endAmount" :precision="0" controls-position="right" :min="0"></el-input-number>
                                    </el-col>
                                    <el-col :span="6" style="margin-left:20px">
                                        <el-col :span="8">运费:</el-col>
                                        <el-col :span="16">
                                            <el-input-number label="运费" v-model="item1.freightAmount" :precision="0" controls-position="right" :min="0"></el-input-number>
                                        </el-col>

                                    </el-col>
                                    <el-col :span="2" style="margin-left:20px">
                                        <el-button v-if="index1==0" type="success" icon="el-icon-plus" circle size="mini" style="font-weight: bolder" @click="addDeliverLine(1,index1)"></el-button>
                                        <el-button v-else type="danger" icon="el-icon-minus" circle size="mini" style="font-weight: bolder" @click="addDeliverLine(-1,index1)"></el-button>
                                    </el-col>
                                </el-row>

                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                </template>
            </el-tabs>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addFreight">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getMallFreightListByPage,saveMallFreightInfo,getProvinceCity,getMallFreightDetail,delMallFreight} from '@/api/api';
    import {provinceAndCityData,CodeToText} from 'element-china-area-data'
    //定义组件
    export default{
        data(){
            return {
                listData:[],
                activeName:'0',
                deliverLabel:[{
                    deliverType:1,
                    name:'冷链运输',
                    data:{
                        deliveryType: "1",
                        freightCityNames:'',
                        freightCityIds:'',
                        sendAmount: "",
                        freightFreeAmount: "",
                        freightRules:[
                            {
                                beginAmount:'',
                                endAmount:'',
                                freightAmount:''
                            }]
                    }
                },{
                    deliverType:2,
                    name:'常温运输',
                    data:{
                        deliveryType: "2",
                        freightCityNames:'',
                        freightCityIds:'',
                        sendAmount: "",
                        freightFreeAmount: "",
                        freightRules:[
                            {
                                beginAmount:'',
                                endAmount:'',
                                freightAmount:''
                            }]
                    }
                },{
                    deliverType:3,
                    name:'极速达',
                    data:{
                        deliveryType: "3",
                        freightCityNames:'',
                        freightCityIds:'',
                        sendAmount: "",
                        freightFreeAmount: "",
                        freightRules:[
                            {
                                beginAmount:'',
                                endAmount:'',
                                freightAmount:''
                            }]
                    }
                },{
                    deliverType:4,
                    name:'超级会员冷链',
                    data:{
                        deliveryType: "4",
                        freightCityNames:'',
                        freightCityIds:'',
                        sendAmount: "",
                        freightFreeAmount: "",
                        freightRules:[
                            {
                                beginAmount:'',
                                endAmount:'',
                                freightAmount:''
                            }]
                    }
                },{
                    deliverType:5,
                    name:'超级会员常温',
                    data:{
                        deliveryType: "5",
                        freightCityNames:'',
                        freightCityIds:'',
                        sendAmount: "",
                        freightFreeAmount: "",
                        freightRules:[
                            {
                                beginAmount:'',
                                endAmount:'',
                                freightAmount:''
                            }]
                    }
                }],
                selectId:'',
                loading:true,
                dialogFormVisible:false,
                options: [],
                props:{
                    label: 'name',
                    children: 'children'
                },
                checkList:'',
                selectedOptions: [],
                form:{
                    "freightCityNames":"",
                    "beginAmount":"",
                    "endAmount":""
                },
                formInline:{
                    platformId:0,
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0
                },
                editDetail:[]
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getList();
            this.getCityList()
        },

        methods:{
            //状态类型转换
            formatDeliveryType: function (type) {
                return type == 0 ? '未设置' : type == 1 ? '已设置' : '未知';
            },
            setDeliveryTitle: function (type) {
                return this.deliverTitle[parseInt(type)]
            },
            getCityList(){
                getProvinceCity({"transportType":2}).then((res) => {
                    console.log(res);
                    this.options = res.data
                });
            },
            //定义查询方法
            getList(){
                this.loading = true;
                getMallFreightListByPage(this.formInline).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.total;
                    this.listData = res.data.list;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList();
            },

            handleCheckChange(data, checked, indeterminate){
                console.log(data, checked, indeterminate);
                console.log(this.$refs.tree.getCheckedNodes());
                this.setCityName(this.$refs.tree.getCheckedNodes())
            },
            setCityName(list){
                let cityId = [];
                let cityName = [];
                list.forEach(function (item,index) {
                    if(item.children==null){
                        cityId.push(item.id)
                        cityName.push(item.name)
                    }
                });
                this.deliverLabel.forEach(function (item) {
                    item.data.freightCityNames=cityName.join(',');
                    item.data.freightCityIds=cityId.join(',');
                })
            },

            //新增事件
            handleAddType(id){
                this.dialogFormVisible = true;
                let _this = this;
                this.selectId = id;
                if(id!=''){
                    getMallFreightDetail({unifyId:id}).then(function (res) {
                        console.log(res)
                        if(res.data.status == 200){
                            res.data.value.forEach(function (item,index) {
                                switch (item.deliveryType){
                                    case '1':
                                        _this.deliverLabel[0].data = item;
                                        break
                                    case '2':
                                        _this.deliverLabel[1].data = item;
                                        break
                                    case '3':
                                        _this.deliverLabel[2].data = item;
                                        break
                                    case '4':
                                        _this.deliverLabel[3].data = item;
                                        break
                                    case '5':
                                        _this.deliverLabel[4].data = item;
                                        break
                                }
                            });
                            _this.$refs.tree.setCheckedKeys(_this.deliverLabel[0].data.freightCityIds.split(','))
                        }else{
                            _this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }else{
                    this.resetDeliverData()
                }
            },
            addDeliverLine(state,index){
                if(state>0){
                    this.deliverLabel[this.activeName].data.freightRules.push({beginAmount:'', endAmount:'', freightAmount:''})
                }else{
                    this.deliverLabel[this.activeName].data.freightRules.splice(index,1)
                }
            },
            resetDeliverData(){
                let _this = this;
                this.activeName = '0';
                if(this.$refs.tree){
                    this.$refs.tree.setCheckedKeys([]);
                }

                this.deliverLabel.forEach(function (item) {
                    item.data.freightCityNames='';
                    item.data.freightCityIds='';
                    item.data.sendAmount='';
                    item.data.freightFreeAmount='';
                    item.data.freightRules = [{
                        beginAmount:'',
                        endAmount:'',
                        freightAmount:''
                    }]
                })
            },

            //确定事件
            addFreight(){
                this.loading = true;
                let _this = this;
                let freightRuleList1 = [];
                let freightRuleList = {};
                this.deliverLabel.forEach(function (item) {
                    freightRuleList1.push(item.data)
                })

                freightRuleList={'freightRuleList':freightRuleList1}
                console.log(freightRuleList)

                let params = {
                    'mallFreightRulesJson' : encodeURIComponent(JSON.stringify(freightRuleList)),
                    'unifyId' : this.selectId
                }

                saveMallFreightInfo(params).then((res) => {
                    this.loading = false;
                    console.log(res)
                    if(res.data.status==200){
                        _this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        _this.dialogFormVisible = false;
                        _this.getList();
                    }else{
                        _this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            deleteFreight(id){
                let _this = this;
                this.$confirm('确定删除选中的行吗？','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delMallFreight({unifyId:id}).then(function (res) {
                        console.log(res);
                        if(res.data.status==200){
                            _this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            _this.dialogFormVisible = false;
                            _this.getList();
                        }else{
                            _this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {
                    _this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        }
    }
</script>
<style scoped>
    .line{
        text-align: center;
    }
    .deliver-wrap{
        padding: 10px;
    }
    .el-input-number{
        width: auto;
    }
</style>



// WEBPACK FOOTER //
// src/views/deliver/mallFreight.vue